import makeStyles from '@mui/styles/makeStyles';

const surface = {
	border: "1px solid var(--atl-border)",
	background: "linear-gradient(180deg, var(--atl-surface-strong) 0%, var(--atl-surface) 100%)",
	color: "var(--atl-text)",
	boxShadow: "var(--atl-shadow)",
	backdropFilter: "blur(10px) saturate(145%)",
	WebkitBackdropFilter: "blur(10px) saturate(145%)",
};

const strongSurface = {
	...surface,
	background: "linear-gradient(180deg, var(--atl-surface-strong) 0%, var(--atl-surface) 12%)",
	boxShadow: "var(--atl-shadow-strong)",
};

const pageControls = {
	"& .MuiTypography-root, & .MuiCardHeader-title": {
		color: "var(--atl-text)",
		letterSpacing: "0 !important",
	},
	"& .MuiCardHeader-subheader, & .MuiTypography-colorTextSecondary": {
		color: "var(--atl-text-soft)",
	},
	"& .MuiOutlinedInput-root": {
		minHeight: 46,
		borderRadius: "14px !important",
		background: "var(--atl-input)",
		boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.14)",
	},
	"& .MuiOutlinedInput-notchedOutline": {
		borderColor: "var(--atl-border)",
	},
	"& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
		borderColor: "color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border))",
	},
	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
		borderColor: "var(--atl-blue)",
		borderWidth: 1,
	},
	"& .MuiInputLabel-root": {
		color: "var(--atl-text-muted)",
		fontWeight: 800,
		letterSpacing: "0 !important",
	},
	"& .MuiInputLabel-root.Mui-focused": {
		color: "var(--atl-blue)",
	},
	"& .MuiButton-root": {
		minHeight: 40,
		borderRadius: "14px !important",
		fontWeight: "800 !important",
		letterSpacing: "0 !important",
		textTransform: "none !important",
		transition: "transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, border-color 0.18s ease !important",
	},
	"& .MuiButton-root:hover, & .MuiIconButton-root:hover": {
		transform: "translateY(-1px)",
	},
	"& .MuiButton-containedPrimary": {
		border: "1px solid color-mix(in srgb, var(--atl-blue-dark) 22%, transparent)",
		background: "linear-gradient(180deg, var(--atl-blue) 0%, var(--atl-blue-dark) 100%)",
		color: "#fff",
		boxShadow: "0 12px 26px color-mix(in srgb, var(--atl-blue) 24%, transparent)",
	},
	"& .MuiIconButton-root": {
		borderRadius: "14px !important",
		transition: "background-color 0.18s ease, transform 0.18s ease !important",
	},
	"& .MuiIconButton-root:hover": {
		background: "color-mix(in srgb, var(--atl-blue) 10%, transparent)",
	},
	"& .MuiChip-root": {
		borderRadius: "999px !important",
		fontWeight: 800,
	},
	"& .MuiToggleButton-root": {
		margin: 4,
		border: "1px solid var(--atl-border) !important",
		borderRadius: "999px !important",
		color: "var(--atl-text)",
		fontWeight: 800,
		textTransform: "none",
	},
};

export const TicketStyle = makeStyles((theme) => ({
	pageRoot: {
		overflow: "hidden",
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 5000,
		color: "#fff",
	},
	pageContainer: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(3),
		...pageControls,
	},
	ticketShell: {
		display: "grid",
		gap: theme.spacing(1.5),
		width: "100%",
		margin: "0 auto",
	},
	ticketHero: {
		...strongSurface,
		borderRadius: "20px !important",
		padding: theme.spacing(1.25),
		display: "grid",
		gap: theme.spacing(1.25),
		overflow: "hidden",
	},
	createButton: {
		width: 40,
		height: 40,
		minWidth: "40px !important",
		minHeight: "40px !important",
		padding: "0 !important",
		border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border)) !important",
		borderRadius: "14px !important",
		background: "color-mix(in srgb, var(--atl-blue) 10%, var(--atl-surface-muted)) !important",
		color: "var(--atl-blue) !important",
		boxShadow: "none !important",
		"& .MuiSvgIcon-root": {
			fontSize: "23px !important",
		},
		"&:hover": {
			borderColor: "color-mix(in srgb, var(--atl-blue) 46%, var(--atl-border)) !important",
			background: "color-mix(in srgb, var(--atl-blue) 16%, var(--atl-surface-muted)) !important",
		},
	},
	searchBar: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) auto",
		gap: theme.spacing(1),
		alignItems: "center",
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
		},
	},
	searchField: {
		"& .MuiOutlinedInput-root": {
			minHeight: 50,
			borderRadius: "16px !important",
			background: "var(--atl-input)",
		},
	},
	filterToggle: {
		minWidth: 50,
		height: 50,
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface-muted)",
		color: "var(--atl-text)",
		[theme.breakpoints.down('sm')]: {
			width: "100%",
		},
	},
	filterToggleActive: {
		borderColor: "color-mix(in srgb, var(--atl-blue) 45%, var(--atl-border)) !important",
		background: "color-mix(in srgb, var(--atl-blue) 12%, var(--atl-surface-muted))",
		color: "var(--atl-blue)",
	},
	statusChip: {
		border: "1px solid var(--atl-border)",
		background: "var(--atl-surface-muted)",
		color: "var(--atl-text)",
	},
	filterPanel: {
		marginTop: theme.spacing(0.25),
		padding: theme.spacing(1.25, 0, 0),
		borderTop: "1px solid var(--atl-border)",
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "start",
		"& > *": {
			width: "100%",
			minWidth: 0,
		},
		"& .MuiTextField-root, & .MuiFormControl-root, & .MuiAutocomplete-root": {
			marginTop: "0 !important",
			marginBottom: "0 !important",
			minWidth: 0,
		},
		"& .MuiOutlinedInput-root": {
			minHeight: "40px !important",
			background: `${theme.palette.mode === "light" ? "#fff" : "#18202c"} !important`,
			backgroundColor: `${theme.palette.mode === "light" ? "#fff" : "#18202c"} !important`,
			backgroundImage: "none !important",
			backgroundClip: "padding-box !important",
			backdropFilter: "none !important",
			WebkitBackdropFilter: "none !important",
		},
		"& [data-solid-autocomplete='true'], & [data-solid-autocomplete='true'] .MuiFormControl-root, & [data-solid-autocomplete='true'] .MuiInputBase-root, & [data-solid-autocomplete='true'] .MuiOutlinedInput-root, & [data-solid-autocomplete='true'] .MuiAutocomplete-inputRoot": {
			background: `${theme.palette.mode === "light" ? "#fff" : "#18202c"} !important`,
			backgroundColor: `${theme.palette.mode === "light" ? "#fff" : "#18202c"} !important`,
			backgroundImage: "none !important",
			backgroundClip: "padding-box !important",
			backdropFilter: "none !important",
			WebkitBackdropFilter: "none !important",
		},
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
		},
	},
	filterGroup: {
		height: "100%",
		width: "100%",
		display: "grid",
		alignContent: "start",
		gap: theme.spacing(0.85),
		padding: theme.spacing(1),
		border: "1px solid color-mix(in srgb, var(--atl-border) 74%, transparent)",
		borderRadius: 16,
		background: "color-mix(in srgb, var(--atl-surface-muted) 42%, transparent)",
	},
	filterGroupWide: {
		gridColumn: "1 / -1",
	},
	filterGroupFields: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
		gap: theme.spacing(1),
		alignItems: "start",
	},
	filterGroupFieldsFour: {
		gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
		gap: theme.spacing(0.75),
		"& $filterField": {
			minWidth: 0,
		},
		"@media (max-width: 900px)": {
			gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		},
		"@media (max-width: 420px)": {
			gridTemplateColumns: "1fr",
		},
	},
	filterField: {
		minWidth: 260,
		[theme.breakpoints.down('sm')]: {
			minWidth: 0,
		},
	},
	filterGroupTitle: {
		color: "var(--atl-text-muted)",
		fontSize: 11,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	filterActions: {
		display: "flex",
		justifyContent: "flex-end",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		paddingTop: theme.spacing(0.25),
		gridColumn: "1 / -1",
	},
	workspace: {
		"--ticket-workspace-height": "auto",
		display: "grid",
		gridTemplateColumns: "316px minmax(0, 1fr)",
		gap: theme.spacing(2),
		alignItems: "start",
		"@media (max-width: 760px)": {
			gridTemplateColumns: "220px minmax(0, 1fr)",
		},
		"@media (max-width: 540px)": {
			gridTemplateColumns: "1fr",
		},
	},
	queuePanel: {
		...strongSurface,
		borderRadius: "24px !important",
		padding: theme.spacing(1.3),
		position: "sticky",
		top: 88,
		height: "max-content",
		alignSelf: "start",
		overflow: "visible",
		"@media (max-width: 540px)": {
			position: "relative",
			top: "auto",
		},
	},
	queueHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: theme.spacing(1),
		padding: theme.spacing(0.6, 0.8, 1.2),
	},
	queueTitle: {
		fontSize: 16,
		fontWeight: 900,
		lineHeight: 1.15,
	},
	queueSubtitle: {
		marginTop: 3,
		color: "var(--atl-text-soft)",
		fontSize: 12,
	},
	queueSection: {
		display: "grid",
		gap: theme.spacing(0.55),
		padding: theme.spacing(0.75, 0),
	},
	queueSectionTitle: {
		margin: theme.spacing(0.75, 0.75, 0.25),
		color: "var(--atl-text-muted)",
		fontSize: 11,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	queueButton: {
		width: "100%",
		display: "grid",
		gridTemplateColumns: "44px minmax(0, 1fr) auto",
		alignItems: "center",
		columnGap: theme.spacing(1.25),
		padding: theme.spacing(1, 1.05),
		border: "1px solid transparent",
		borderRadius: "16px !important",
		background: "transparent",
		color: "var(--atl-text)",
		textAlign: "left",
		cursor: "pointer",
		transition: "background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 28%, transparent)",
			background: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 9%, transparent)",
		},
	},
	queueButtonActive: {
		borderColor: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 42%, var(--atl-border))",
		background: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 14%, var(--atl-surface-muted))",
	},
	queueIcon: {
		width: 36,
		height: 36,
		borderRadius: 14,
		display: "grid",
		placeItems: "center",
		color: "var(--queue-color, var(--atl-blue))",
		background: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 13%, transparent)",
	},
	queueCopy: {
		display: "grid",
		gap: 4,
		minWidth: 0,
	},
	queueItemTitle: {
		fontSize: 14,
		fontWeight: 900,
		lineHeight: 1.15,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	queueItemDescription: {
		color: "var(--atl-text-soft)",
		fontSize: 12,
		lineHeight: 1.25,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	queueCount: {
		minWidth: 30,
		height: 24,
		padding: theme.spacing(0, 0.75),
		borderRadius: 999,
		display: "inline-grid",
		placeItems: "center",
		justifySelf: "end",
		background: "color-mix(in srgb, var(--queue-color, var(--atl-blue)) 16%, var(--atl-surface-strong))",
		color: "var(--atl-text)",
		fontSize: 12,
		fontWeight: 900,
		lineHeight: 1,
	},
	queueDivider: {
		borderColor: "var(--atl-border)",
		margin: theme.spacing(0.75, 0),
	},
	listPanel: {
		...strongSurface,
		borderRadius: "24px !important",
		minWidth: 0,
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		minHeight: 0,
		height: "var(--ticket-workspace-height)",
		maxHeight: "var(--ticket-workspace-height)",
		alignSelf: "start",
	},
	listHeader: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
		gap: theme.spacing(1.2, 2),
		alignItems: "start",
		padding: theme.spacing(2, 2.25),
		borderBottom: "1px solid var(--atl-border)",
	},
	listHeading: {
		minWidth: 0,
	},
	listTitle: {
		margin: 0,
		fontSize: 21,
		fontWeight: 900,
		lineHeight: 1.18,
		overflowWrap: "break-word",
	},
	listSubtitle: {
		marginTop: theme.spacing(0.5),
		color: "var(--atl-text-soft)",
		fontSize: 14,
		lineHeight: 1.45,
		maxWidth: "58ch",
		overflowWrap: "break-word",
	},
	listChips: {
		display: "flex",
		justifyContent: "flex-end",
		flexWrap: "wrap",
		gap: theme.spacing(0.75),
		alignItems: "flex-start",
		alignContent: "flex-start",
		width: "100%",
		minWidth: 0,
	},
	listSortControls: {
		flex: "1 1 220px",
		maxWidth: 320,
		minWidth: 0,
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) 40px",
		gap: theme.spacing(0.65),
		alignItems: "center",
	},
	listSortSelect: {
		minWidth: "0 !important",
		"& .MuiOutlinedInput-root": {
			minHeight: "40px !important",
			borderRadius: "14px !important",
		},
		"& .MuiAutocomplete-inputRoot": {
			minWidth: "0 !important",
		},
		"& .MuiAutocomplete-input, & .MuiInputBase-input": {
			minWidth: "0 !important",
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
	},
	directionToggle: {
		width: 40,
		height: 40,
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface-muted)",
		color: "var(--atl-text)",
		"&:hover": {
			color: "var(--atl-blue)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
		},
	},
	ticketList: {
		flex: "1 1 auto",
		minHeight: 0,
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr)",
		alignContent: "start",
		gap: theme.spacing(1.25),
		overflowY: "auto",
		overflowX: "hidden",
		padding: theme.spacing(2),
		scrollbarWidth: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
	},
	ticketCard: {
		...surface,
		height: 258,
		minHeight: 258,
		display: "flex",
		flexDirection: "column",
		borderRadius: "20px !important",
		overflow: "hidden",
		boxShadow: "none",
		transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 32%, var(--atl-border))",
			boxShadow: "var(--atl-shadow)",
		},
		"@media (max-width: 760px)": {
			height: 272,
			minHeight: 272,
		},
		"@media (max-width: 540px)": {
			height: 258,
			minHeight: 258,
		},
	},
	ticketCardInner: {
		width: "100%",
		height: "100%",
		minHeight: 258,
		display: "grid",
		gridTemplateRows: "minmax(0, 1fr) auto",
		minWidth: 0,
		overflow: "hidden",
	},
	ticketCardAction: {
		display: "block",
		width: "100%",
		height: "100%",
		minHeight: 0,
		textAlign: "left",
		color: "inherit",
		background: "transparent",
		"&:hover": {
			background: "color-mix(in srgb, var(--atl-blue) 5%, transparent)",
		},
		"& .MuiCardActionArea-focusHighlight": {
			background: "color-mix(in srgb, var(--atl-blue) 10%, transparent)",
		},
	},
	ticketCardHighlightUser: {
		background: "linear-gradient(90deg, color-mix(in srgb, #42a5f5 14%, transparent), transparent 55%)",
	},
	ticketCardHighlightCall: {
		background: "linear-gradient(90deg, color-mix(in srgb, #ef5350 15%, transparent), transparent 58%)",
	},
	ticketCardContent: {
		height: "100%",
		minHeight: 0,
		display: "grid",
		gridTemplateRows: "auto minmax(0, 1fr)",
		padding: theme.spacing(1.35, 1.45, 1),
		gap: theme.spacing(0.95),
	},
	ticketCardHeader: {
		display: "grid",
		gridTemplateColumns: "42px minmax(0, 1fr) auto",
		gap: theme.spacing(1.1),
		alignItems: "center",
		minWidth: 0,
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "38px minmax(0, 1fr)",
		},
	},
	ticketAvatar: {
		width: 42,
		height: 42,
		color: "#fff",
		fontWeight: 900,
		background: "linear-gradient(180deg, var(--atl-cyan) 0%, var(--atl-blue) 100%)",
		boxShadow: "inset 0 0 0 1px var(--atl-border)",
		[theme.breakpoints.down('sm')]: {
			width: 38,
			height: 38,
		},
	},
	ticketMainInfo: {
		minWidth: 0,
	},
	ticketCardTitle: {
		fontSize: 15.5,
		fontWeight: 900,
		lineHeight: 1.18,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	ticketCardSubtitle: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 12.5,
		lineHeight: 1.32,
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 2,
		overflow: "hidden",
	},
	ticketMeta: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		gap: theme.spacing(0.7),
		color: "var(--atl-text-soft)",
		fontSize: 12,
		textAlign: "right",
		[theme.breakpoints.down('sm')]: {
			display: "none",
		},
	},
	priorityChip: {
		color: "#fff !important",
		minWidth: 72,
		fontWeight: "900 !important",
	},
	ticketCardBody: {
		display: "grid",
		gap: theme.spacing(0.85),
		minWidth: 0,
		minHeight: 0,
		alignContent: "start",
		alignSelf: "start",
	},
	ticketBodyGrid: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) 50px",
		gap: theme.spacing(1),
		alignItems: "start",
		minWidth: 0,
		minHeight: 0,
	},
	ticketIdentityGrid: {
		display: "grid",
		gridTemplateColumns: "82px minmax(0, 1fr)",
		gap: theme.spacing(0.75),
		alignItems: "stretch",
		minWidth: 0,
		overflow: "hidden",
	},
	ticketFact: {
		minHeight: 43,
		minWidth: 0,
		display: "grid",
		alignContent: "center",
		gap: 2,
		padding: theme.spacing(0.5, 0.75),
		border: "1px solid color-mix(in srgb, var(--atl-border) 82%, transparent)",
		borderRadius: 12,
		background: "color-mix(in srgb, var(--atl-surface-muted) 44%, transparent)",
		cursor: "copy",
		outline: "none",
		transition: "background-color 0.16s ease, border-color 0.16s ease",
		"&:hover, &:focus-visible": {
			borderColor: "color-mix(in srgb, var(--atl-blue) 34%, var(--atl-border))",
			background: "color-mix(in srgb, var(--atl-blue) 8%, var(--atl-surface-muted))",
		},
		"&:hover $ticketFactValue, &:focus-visible $ticketFactValue": {
			color: "var(--atl-blue)",
		},
	},
	ticketFactCompact: {
		width: 82,
	},
	ticketFactLabel: {
		color: "var(--atl-text-muted)",
		fontSize: 9.5,
		fontWeight: 800,
		lineHeight: 1,
		textTransform: "uppercase",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	ticketFactValue: {
		minWidth: 0,
		color: "var(--atl-text)",
		fontSize: 13.2,
		fontWeight: 700,
		lineHeight: 1.12,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		transition: "color 0.16s ease",
	},
	ticketMessageBlock: {
		minHeight: 74,
		alignContent: "start",
		cursor: "default",
		"&:hover, &:focus-visible": {
			borderColor: "color-mix(in srgb, var(--atl-border) 82%, transparent)",
			background: "color-mix(in srgb, var(--atl-surface-muted) 44%, transparent)",
		},
	},
	ticketDescription: {
		color: "var(--atl-text-soft)",
		fontSize: 14,
		lineHeight: 1.32,
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 3,
		overflow: "hidden",
	},
	ticketPlayButton: {
		width: 46,
		height: 46,
		justifySelf: "end",
		alignSelf: "center",
		border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border)) !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(180deg, color-mix(in srgb, #fff 88%, var(--atl-blue) 12%) 0%, color-mix(in srgb, #fff 74%, var(--atl-blue) 26%) 100%) !important"
			: "linear-gradient(180deg, color-mix(in srgb, var(--atl-surface-strong) 78%, var(--atl-blue) 22%) 0%, color-mix(in srgb, var(--atl-surface) 82%, var(--atl-blue) 18%) 100%) !important",
		color: "var(--atl-blue) !important",
		boxShadow: theme.palette.mode === "light"
			? "0 10px 20px rgba(28, 54, 78, 0.08)"
			: "0 12px 22px rgba(0, 0, 0, 0.22)",
		"& .MuiSvgIcon-root": {
			fontSize: "30px !important",
			transform: "translateX(1px)",
		},
		"&:hover": {
			borderColor: "color-mix(in srgb, var(--atl-blue) 46%, var(--atl-border)) !important",
			background: theme.palette.mode === "light"
				? "linear-gradient(180deg, color-mix(in srgb, #fff 78%, var(--atl-blue) 22%) 0%, color-mix(in srgb, #fff 62%, var(--atl-blue) 38%) 100%) !important"
				: "linear-gradient(180deg, color-mix(in srgb, var(--atl-surface-strong) 64%, var(--atl-blue) 36%) 0%, color-mix(in srgb, var(--atl-surface) 68%, var(--atl-blue) 32%) 100%) !important",
			boxShadow: theme.palette.mode === "light"
				? "0 12px 22px rgba(28, 54, 78, 0.12)"
				: "0 14px 24px rgba(0, 0, 0, 0.28)",
		},
	},
	ticketFooter: {
		minHeight: 48,
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) auto",
		gap: theme.spacing(1),
		alignItems: "center",
		padding: theme.spacing(0.75, 1.15),
		borderTop: "1px solid var(--atl-border)",
		background: "color-mix(in srgb, var(--atl-surface-muted) 62%, transparent)",
	},
	ticketTags: {
		display: "flex",
		flexWrap: "nowrap",
		alignItems: "center",
		gap: theme.spacing(0.5),
		minWidth: 0,
		overflow: "hidden",
	},
	ticketTag: {
		margin: "0 !important",
		flex: "0 0 auto",
		maxWidth: 180,
		border: "1px solid color-mix(in srgb, var(--ticket-chip-color, var(--atl-blue)) 32%, transparent) !important",
		background: "color-mix(in srgb, var(--ticket-chip-color, var(--atl-blue)) 14%, var(--atl-surface-muted)) !important",
		color: "var(--atl-text) !important",
		"& .MuiChip-label": {
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
		"& .MuiChip-icon": {
			color: "var(--ticket-chip-color, var(--atl-blue)) !important",
			marginLeft: "7px !important",
		},
	},
	ticketQuickActions: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(0.5),
		flex: "0 0 auto",
	},
	ticketIconButton: {
		width: 34,
		height: 34,
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface-muted) !important",
		color: "var(--atl-text-soft) !important",
		"&:hover": {
			color: "var(--atl-blue) !important",
			borderColor: "color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
			background: "color-mix(in srgb, var(--atl-blue) 10%, var(--atl-surface-muted)) !important",
		},
	},
	ticketHistoryContent: {
		background: "var(--atl-surface-solid-strong) !important",
		backgroundColor: "var(--atl-surface-solid-strong) !important",
		backgroundImage: "none !important",
		backdropFilter: "none !important",
		WebkitBackdropFilter: "none !important",
		scrollbarWidth: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
	},
	ticketHistoryLoading: {
		display: "grid",
		gap: theme.spacing(1.2),
		padding: theme.spacing(1.6),
	},
	historyTimeline: {
		display: "grid",
		gap: theme.spacing(0.6),
		padding: theme.spacing(1.05, 0.25, 0.4),
	},
	historyEmpty: {
		minHeight: 260,
		display: "grid",
		placeItems: "center",
		alignContent: "center",
		gap: theme.spacing(1),
		padding: theme.spacing(4),
		textAlign: "center",
		color: "var(--atl-text-soft)",
		"& .MuiAvatar-root": {
			width: 56,
			height: 56,
			background: "color-mix(in srgb, var(--atl-blue) 14%, transparent)",
			color: "var(--atl-blue)",
		},
		"& h3": {
			margin: 0,
			color: "var(--atl-text)",
			fontSize: 18,
			fontWeight: 900,
		},
		"& p": {
			margin: 0,
			fontSize: 14,
		},
	},
	historyItem: {
		display: "grid",
		gridTemplateColumns: "42px minmax(0, 1fr)",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	historyRail: {
		position: "relative",
		display: "grid",
		justifyItems: "center",
		alignContent: "start",
		paddingTop: 3,
	},
	historyDot: {
		width: 36,
		height: 36,
		zIndex: 1,
		border: "1px solid color-mix(in srgb, var(--history-color) 26%, var(--atl-border))",
		background: "var(--atl-surface-solid-muted) !important",
		color: "var(--history-color) !important",
		boxShadow: "none",
		"& .MuiSvgIcon-root": {
			fontSize: 20,
		},
	},
	historyLine: {
		position: "absolute",
		top: 40,
		bottom: -8,
		width: 2,
		borderRadius: 2,
		background: "var(--atl-border)",
	},
	historyEntry: {
		minWidth: 0,
		marginBottom: theme.spacing(1),
		padding: theme.spacing(1.05, 1.2, 1.15),
		border: "1px solid color-mix(in srgb, var(--history-color) 30%, var(--atl-border)) !important",
		borderRadius: "18px !important",
		boxShadow: "none",
	},
	historyEntryHeader: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(0.75),
		minWidth: 0,
		overflow: "hidden",
		"@media (max-width: 620px)": {
			gap: theme.spacing(0.4),
			flexWrap: "wrap",
		},
	},
	historyEntryKicker: {
		display: "inline-flex",
		flex: "0 0 auto",
		color: "var(--history-color)",
		fontSize: "14px !important",
		fontWeight: "850 !important",
		lineHeight: "1.2 !important",
		textTransform: "uppercase",
	},
	historyEntryTitle: {
		margin: "0 !important",
		minWidth: 0,
		flex: "1 1 auto",
		color: "var(--atl-text)",
		fontSize: "14px !important",
		fontWeight: "850 !important",
		lineHeight: "1.2 !important",
		letterSpacing: "0 !important",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	historyEntryMeta: {
		flex: "0 0 auto",
		padding: theme.spacing(0.35, 0.65),
		border: "1px solid var(--atl-border)",
		borderRadius: 999,
		background: "color-mix(in srgb, var(--atl-surface-solid-muted) 76%, var(--atl-surface-solid))",
		color: "var(--atl-text)",
		fontSize: "11px !important",
		fontWeight: "750 !important",
		lineHeight: "1 !important",
		whiteSpace: "nowrap",
		"@media (max-width: 620px)": {
			flex: "0 0 auto",
		},
	},
	historyEntryNote: {
		marginTop: theme.spacing(0.9),
		padding: theme.spacing(0.75, 0.9),
		border: "1px solid color-mix(in srgb, var(--atl-border) 82%, transparent)",
		borderRadius: 12,
		color: "var(--atl-text)",
		fontSize: "14px !important",
		lineHeight: "1.48 !important",
		whiteSpace: "pre-wrap",
		wordBreak: "break-word",
		"& p": {
			margin: 0,
		},
	},
	historyBadges: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(0.6),
		marginTop: theme.spacing(0.8),
	},
	historyChip: {
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface-solid-muted) !important",
		color: "var(--atl-text) !important",
		fontWeight: "800 !important",
		"& .MuiChip-icon": {
			color: "var(--history-color) !important",
		},
	},
	historyResolvedChip: {
		"--history-color": "#34a853",
	},
	historyResolvedRow: {
		display: "flex",
		justifyContent: "center",
		flex: "1 1 100%",
		width: "100%",
	},
	ticketAlert: {
		...surface,
		borderRadius: "18px !important",
		boxShadow: "none",
	},
	ticketDetailContainer: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(3.5),
	},
	ticketDetailShell: {
		display: "grid",
		gap: theme.spacing(1.5),
		width: "100%",
		minWidth: 0,
	},
	ticketDetailTopGrid: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 3fr) minmax(260px, 1fr)",
		gap: theme.spacing(1.5),
		alignItems: "stretch",
		minWidth: 0,
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailHero: {
		...strongSurface,
		borderRadius: "22px !important",
		padding: theme.spacing(1.6),
		display: "grid",
		gap: theme.spacing(1.35),
		overflow: "hidden",
	},
	ticketDetailHeroTop: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) auto",
		gap: theme.spacing(1.25),
		alignItems: "start",
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailHeroMain: {
		display: "grid",
		gridTemplateColumns: "58px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "center",
		minWidth: 0,
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "48px minmax(0, 1fr)",
		},
	},
	ticketDetailAvatar: {
		width: "58px !important",
		height: "58px !important",
		borderRadius: "18px !important",
		background: "color-mix(in srgb, var(--atl-blue) 14%, var(--atl-surface-muted)) !important",
		color: "var(--atl-blue) !important",
		boxShadow: "inset 0 0 0 1px color-mix(in srgb, var(--atl-blue) 22%, transparent)",
		"& .MuiSvgIcon-root": {
			fontSize: "30px !important",
		},
		[theme.breakpoints.down('sm')]: {
			width: "48px !important",
			height: "48px !important",
			borderRadius: "16px !important",
		},
	},
	ticketDetailHeroCopy: {
		minWidth: 0,
	},
	ticketDetailKicker: {
		margin: "0 0 2px !important",
		color: "var(--atl-blue)",
		fontSize: "12px !important",
		fontWeight: "850 !important",
		lineHeight: "1.1 !important",
		textTransform: "uppercase",
	},
	ticketDetailTitle: {
		margin: "0 !important",
		color: "var(--atl-text)",
		fontSize: "clamp(24px, 2vw, 34px) !important",
		fontWeight: "850 !important",
		lineHeight: "1.08 !important",
		letterSpacing: "0 !important",
		overflowWrap: "anywhere",
	},
	ticketDetailSubtitle: {
		margin: "6px 0 0 !important",
		color: "var(--atl-text-soft)",
		fontSize: "15px !important",
		fontWeight: "750 !important",
		lineHeight: "1.25 !important",
		overflowWrap: "anywhere",
	},
	ticketDetailBadges: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(0.7),
		minWidth: 0,
		[theme.breakpoints.down('md')]: {
			justifyContent: "flex-start",
		},
	},
	ticketDetailChip: {
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface-muted) !important",
		color: "var(--atl-text) !important",
		fontWeight: "850 !important",
	},
	ticketDetailRequestPanel: {
		display: "grid",
		gridTemplateRows: "auto minmax(0, 1fr) auto",
		gap: theme.spacing(1),
		"& $ticketDetailBadges": {
			justifyContent: "flex-start",
			padding: theme.spacing(0, 1.55, 1.45),
		},
	},
	ticketDetailRequestFooter: {
		display: "flex",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1.55, 1.35),
	},
	ticketDetailCustomerPanel: {
		display: "grid",
		gridTemplateRows: "auto minmax(0, 1fr)",
	},
	ticketDetailRequestText: {
		margin: theme.spacing(0, 1.55),
		padding: theme.spacing(1.05, 1.15),
		minHeight: 104,
		border: "1px solid var(--atl-border)",
		borderRadius: 16,
		background: "var(--atl-surface-muted)",
		color: "var(--atl-text)",
		fontSize: "15px !important",
		fontWeight: "650 !important",
		lineHeight: "1.45 !important",
		overflowWrap: "anywhere",
	},
	ticketDetailMessage: {
		margin: "0 !important",
		padding: theme.spacing(1.1, 1.25),
		border: "1px solid var(--atl-border)",
		borderRadius: "16px",
		background: "var(--atl-surface-muted)",
		color: "var(--atl-text)",
		fontSize: "15px !important",
		fontWeight: "650 !important",
		lineHeight: "1.45 !important",
		overflowWrap: "anywhere",
	},
	ticketDetailFacts: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
		gap: theme.spacing(0.9),
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailFact: {
		minWidth: 0,
		display: "grid",
		gridTemplateColumns: "34px minmax(0, 1fr)",
		columnGap: theme.spacing(0.75),
		rowGap: 2,
		alignItems: "center",
		padding: theme.spacing(0.85, 1),
		border: "1px solid var(--atl-border)",
		borderRadius: "15px",
		background: "color-mix(in srgb, var(--atl-surface-muted) 72%, transparent)",
	},
	ticketDetailFactIcon: {
		gridRow: "1 / span 2",
		width: 34,
		height: 34,
		borderRadius: 12,
		display: "grid",
		placeItems: "center",
		background: "color-mix(in srgb, var(--atl-blue) 12%, transparent)",
		color: "var(--atl-blue)",
		"& .MuiSvgIcon-root": {
			fontSize: 20,
		},
	},
	ticketDetailFactLabel: {
		minWidth: 0,
		color: "var(--atl-text-muted)",
		fontSize: "10px",
		fontWeight: 900,
		lineHeight: 1,
		textTransform: "uppercase",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	ticketDetailFactValue: {
		minWidth: 0,
		color: "var(--atl-text)",
		fontSize: "13px",
		fontWeight: 800,
		lineHeight: 1.18,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	ticketDetailMiniFacts: {
		display: "grid",
		gridTemplateColumns: "1fr",
		gap: theme.spacing(0.75),
		padding: theme.spacing(0.2, 1.55, 1.45),
		"& $ticketDetailFact": {
			padding: theme.spacing(0.7, 0.85),
		},
	},
	ticketDetailInfoPanel: {
		display: "grid",
		gap: theme.spacing(1.1),
		padding: theme.spacing(1.35, 1.55, 1.5),
	},
	ticketDetailInfoHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
		[theme.breakpoints.down('sm')]: {
			flexDirection: "column",
		},
	},
	ticketDetailLayout: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) minmax(390px, 0.58fr)",
		gap: theme.spacing(1.5),
		alignItems: "start",
		minWidth: 0,
		[theme.breakpoints.down('lg')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailPrimary: {
		display: "grid",
		gap: theme.spacing(1.5),
		minWidth: 0,
	},
	ticketDetailSidebar: {
		display: "grid",
		gap: theme.spacing(1.5),
		minWidth: 0,
		alignSelf: "start",
		[theme.breakpoints.down('lg')]: {
			order: -1,
		},
	},
	ticketDetailWorkGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: theme.spacing(1.5),
		alignItems: "start",
		minWidth: 0,
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailFormRow: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: theme.spacing(1.5),
		alignItems: "start",
		minWidth: 0,
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailHistoryRow: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 3fr) minmax(0, 1fr)",
		gap: theme.spacing(1.5),
		alignItems: "start",
		minWidth: 0,
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	ticketDetailPanel: {
		...surface,
		borderRadius: "22px !important",
		overflow: "hidden",
		minWidth: 0,
		"& .MuiCardHeader-root": {
			padding: theme.spacing(1.35, 1.55, 0.85),
		},
		"& .MuiCardHeader-title": {
			color: "var(--atl-text)",
			fontSize: "18px !important",
			fontWeight: "850 !important",
			lineHeight: "1.18 !important",
		},
		"& .MuiCardHeader-subheader": {
			color: "var(--atl-text-soft)",
			fontSize: "13px !important",
			fontWeight: "700 !important",
			lineHeight: "1.25 !important",
		},
	},
	ticketModifyPanel: {
		"& .MuiCardContent-root > form > .MuiGrid-container > .MuiGrid-root": {
			flexBasis: "100% !important",
			maxWidth: "100% !important",
			width: "100% !important",
		},
		"& .MuiTextField-root, & .MuiFormControl-root, & .MuiAutocomplete-root": {
			width: "100% !important",
			minWidth: "0 !important",
		},
		"& .MuiInputBase-multiline textarea": {
			maxHeight: "92px !important",
		},
	},
	ticketSummaryForm: {
		display: "grid",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	ticketSummaryBody: {
		display: "grid",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	ticketSummarySection: {
		display: "grid",
		gap: theme.spacing(0.9),
		padding: theme.spacing(1),
		border: "1px solid var(--atl-border) !important",
		borderRadius: "18px !important",
		background: "var(--atl-surface-muted) !important",
		minWidth: 0,
		"& $detailActions": {
			borderTop: "0 !important",
			justifyContent: "flex-end",
			padding: "0 !important",
		},
	},
	ticketSummarySectionHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
		[theme.breakpoints.down('sm')]: {
			alignItems: "flex-start",
			flexDirection: "column",
		},
	},
	ticketSummarySectionTitle: {
		margin: "0 !important",
		color: "var(--atl-text)",
		fontSize: "14px !important",
		fontWeight: "850 !important",
		lineHeight: "1.18 !important",
	},
	ticketSummarySectionSubtitle: {
		margin: "3px 0 0 !important",
		color: "var(--atl-text-soft)",
		fontSize: "12px !important",
		fontWeight: "650 !important",
		lineHeight: "1.25 !important",
	},
	ticketSummaryFactsGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
		gap: theme.spacing(0.75),
		minWidth: 0,
		"@media (max-width: 520px)": {
			gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		},
	},
	ticketSummaryControlsGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(1),
		minWidth: 0,
		"@media (max-width: 520px)": {
			gridTemplateColumns: "1fr",
		},
	},
	ticketSummaryMetaGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(1),
		minWidth: 0,
		"@media (max-width: 520px)": {
			gridTemplateColumns: "1fr",
		},
	},
	ticketSummaryField: {
		minWidth: "0 !important",
		"& .MuiInputBase-root": {
			borderRadius: "14px !important",
			background: "var(--atl-surface-solid) !important",
			color: "var(--atl-text) !important",
		},
		"& .MuiOutlinedInput-root": {
			background: "var(--atl-surface-solid) !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "var(--atl-border) !important",
		},
		"& .MuiSelect-select": {
			minHeight: "20px !important",
			display: "flex !important",
			alignItems: "center !important",
			paddingTop: "10px !important",
			paddingBottom: "10px !important",
			background: "var(--atl-surface-solid) !important",
			boxSizing: "border-box",
		},
		"& .MuiInputLabel-root": {
			color: "var(--atl-text-soft) !important",
			fontWeight: "750 !important",
		},
	},
	ticketSummaryTags: {
		minWidth: 0,
		"& .MuiInputBase-root": {
			borderRadius: "14px !important",
			background: "var(--atl-surface-solid) !important",
			color: "var(--atl-text) !important",
		},
		"& .MuiOutlinedInput-root": {
			background: "var(--atl-surface-solid) !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "var(--atl-border) !important",
		},
		"& .MuiInputBase-input": {
			background: "transparent !important",
		},
		"& .MuiInputLabel-root": {
			color: "var(--atl-text-soft) !important",
			fontWeight: "750 !important",
		},
	},
	ticketSummarySelectValue: {
		"--ticket-select-color": "var(--atl-blue)",
		display: "inline-flex",
		alignItems: "center",
		gap: theme.spacing(0.65),
		minWidth: 0,
		color: "var(--atl-text)",
		fontSize: "13px",
		fontWeight: 800,
		lineHeight: "20px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		"& .MuiSvgIcon-root": {
			color: "var(--ticket-select-color)",
			fontSize: "18px",
			flex: "0 0 auto",
		},
	},
	ticketSummarySelectAdornment: {
		color: "var(--ticket-select-color) !important",
		fontSize: "18px !important",
		marginRight: theme.spacing(0.35),
		flex: "0 0 auto",
	},
	ticketSummaryDialogField: {
		width: "100%",
		marginTop: `${theme.spacing(1.25)} !important`,
		"& .MuiInputBase-root": {
			borderRadius: "14px !important",
			background: "var(--atl-surface-solid) !important",
		},
	},
	ticketSolidMenuPaper: {
		background: "var(--atl-surface-solid) !important",
		color: "var(--atl-text) !important",
		border: "1px solid var(--atl-border) !important",
		boxShadow: "var(--atl-shadow) !important",
		backdropFilter: "none !important",
		WebkitBackdropFilter: "none !important",
	},
	ticketPracticeDialog: {
		background: "var(--atl-surface-solid-strong) !important",
		backgroundColor: "var(--atl-surface-solid-strong) !important",
		backgroundImage: "none !important",
		backgroundClip: "padding-box !important",
		backdropFilter: "none !important",
		WebkitBackdropFilter: "none !important",
		"& .MuiDialogTitle-root": {
			background: "var(--atl-surface-solid-strong) !important",
			backgroundColor: "var(--atl-surface-solid-strong) !important",
			backgroundImage: "none !important",
		},
		"& .MuiDialogContent-root": {
			background: "var(--atl-surface-solid-strong) !important",
			backgroundColor: "var(--atl-surface-solid-strong) !important",
			backgroundImage: "none !important",
		},
		"& .MuiDialogActions-root": {
			background: "var(--atl-surface-solid-strong) !important",
			backgroundColor: "var(--atl-surface-solid-strong) !important",
			backgroundImage: "none !important",
		},
	},
	ticketPracticeDialogContent: {
		"& .MuiCard-root": {
			border: "0 !important",
			borderRadius: "0 !important",
			background: "var(--atl-surface-solid-strong) !important",
			backgroundColor: "var(--atl-surface-solid-strong) !important",
			backgroundImage: "none !important",
			boxShadow: "none !important",
			backdropFilter: "none !important",
			WebkitBackdropFilter: "none !important",
		},
		"& .MuiCardHeader-root": {
			display: "none",
		},
		"& .MuiCardContent-root": {
			padding: "0 !important",
		},
		"& .MuiCardActions-root": {
			padding: `${theme.spacing(1.25, 0, 0)} !important`,
			borderTop: "0 !important",
			background: "var(--atl-surface-solid-strong) !important",
			backgroundColor: "var(--atl-surface-solid-strong) !important",
			backgroundImage: "none !important",
			boxShadow: "none !important",
		},
	},
	ticketDynamicLauncher: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		padding: theme.spacing(1.3, 1.55),
		[theme.breakpoints.down('sm')]: {
			alignItems: "stretch",
			flexDirection: "column",
		},
	},
	historyComposer: {
		marginTop: theme.spacing(1.25),
		padding: theme.spacing(1.1),
		border: "1px solid var(--atl-border) !important",
		borderRadius: "18px !important",
		boxShadow: "none !important",
	},
	historyComposerHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		marginBottom: theme.spacing(1),
		[theme.breakpoints.down('sm')]: {
			flexDirection: "column",
		},
	},
	historyComposerForm: {
		display: "grid",
		gap: theme.spacing(1),
		"& .MuiInputBase-root": {
			borderRadius: "16px !important",
			background: "var(--atl-surface-solid) !important",
		},
		"& .MuiInputBase-multiline textarea": {
			maxHeight: "92px !important",
		},
	},
	historyComposerActions: {
		display: "flex",
		justifyContent: "flex-end",
	},
	ticketDetailPanelHeader: {
		display: "grid",
		gridTemplateColumns: "44px minmax(0, 1fr)",
		gap: theme.spacing(1),
		alignItems: "center",
		padding: theme.spacing(1.35, 1.55, 0.85),
		minWidth: 0,
	},
	ticketDetailPanelIcon: {
		width: "44px !important",
		height: "44px !important",
		borderRadius: "15px !important",
		background: "color-mix(in srgb, var(--atl-blue) 12%, var(--atl-surface-muted)) !important",
		color: "var(--atl-blue) !important",
		boxShadow: "inset 0 0 0 1px color-mix(in srgb, var(--atl-blue) 22%, transparent)",
	},
	ticketDetailPanelTitle: {
		margin: "0 !important",
		color: "var(--atl-text)",
		fontSize: "18px !important",
		fontWeight: "850 !important",
		lineHeight: "1.18 !important",
	},
	ticketDetailPanelSubtitle: {
		margin: "4px 0 0 !important",
		color: "var(--atl-text-soft)",
		fontSize: "13px !important",
		fontWeight: "700 !important",
		lineHeight: "1.25 !important",
	},
	ticketDetailPanelContent: {
		padding: `${theme.spacing(0.75, 1.55, 1.45)} !important`,
		flexGrow: 0,
	},
	ticketDetailOptionPanel: {
		border: "1px solid var(--atl-border) !important",
		borderRadius: "18px !important",
		background: "var(--atl-surface-muted) !important",
		boxShadow: "none !important",
		padding: theme.spacing(1),
		display: "grid",
		gap: theme.spacing(0.8),
	},
	ticketDetailOptionTitle: {
		margin: "0 !important",
		color: "var(--atl-text)",
		fontSize: "14px !important",
		fontWeight: "850 !important",
		lineHeight: "1.2 !important",
	},
	ticketDetailOptionCopy: {
		margin: "0 !important",
		color: "var(--atl-text-soft)",
		fontSize: "12px !important",
		fontWeight: "650 !important",
		lineHeight: "1.3 !important",
	},
	ticketDetailToggleGroup: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(0.6),
	},
	ticketDetailToggleButton: {
		"--ticket-toggle-color": "var(--atl-blue)",
		minHeight: "36px !important",
		margin: "0 !important",
		padding: theme.spacing(0.55, 1),
		border: "1px solid var(--atl-border) !important",
		borderRadius: "12px !important",
		background: "var(--atl-surface-solid) !important",
		color: "var(--atl-text-soft) !important",
		fontSize: "12px !important",
		fontWeight: "850 !important",
		lineHeight: "1 !important",
		textTransform: "none !important",
		"& .MuiSvgIcon-root": {
			color: "var(--ticket-toggle-color)",
			fontSize: "18px !important",
			marginLeft: theme.spacing(0.55),
		},
		"&.Mui-selected": {
			borderColor: "color-mix(in srgb, var(--ticket-toggle-color) 44%, var(--atl-border)) !important",
			background: "color-mix(in srgb, var(--ticket-toggle-color) 12%, var(--atl-surface-solid)) !important",
			color: "var(--atl-text) !important",
		},
		"&.Mui-selected:hover, &:hover": {
			borderColor: "color-mix(in srgb, var(--ticket-toggle-color) 52%, var(--atl-border)) !important",
			background: "color-mix(in srgb, var(--ticket-toggle-color) 15%, var(--atl-surface-solid)) !important",
		},
	},
	ticketDetailSwitch: {
		margin: "0 !important",
		alignItems: "flex-start",
		color: "var(--atl-text)",
		"& .MuiFormControlLabel-label": {
			color: "var(--atl-text)",
			fontSize: "13px !important",
			fontWeight: "750 !important",
			lineHeight: "1.25 !important",
		},
	},
	ticketDetailActionButton: {
		"--ticket-action-color": "var(--atl-blue)",
		border: "1px solid color-mix(in srgb, var(--ticket-action-color) 34%, var(--atl-border)) !important",
		background: "color-mix(in srgb, var(--ticket-action-color) 10%, var(--atl-surface-solid)) !important",
		color: "var(--atl-text) !important",
		boxShadow: "none !important",
		"& .MuiSvgIcon-root": {
			color: "var(--ticket-action-color) !important",
			fontSize: "20px !important",
		},
		"&:hover": {
			borderColor: "color-mix(in srgb, var(--ticket-action-color) 48%, var(--atl-border)) !important",
			background: "color-mix(in srgb, var(--ticket-action-color) 15%, var(--atl-surface-solid)) !important",
			boxShadow: "0 10px 20px color-mix(in srgb, var(--ticket-action-color) 14%, transparent) !important",
		},
	},
	ticketDetailActionPrimary: {
		"--ticket-action-color": "var(--atl-blue)",
	},
	ticketDetailActionSuccess: {
		"--ticket-action-color": "var(--atl-green)",
	},
	ticketDetailActionWarning: {
		"--ticket-action-color": "var(--atl-yellow)",
	},
	ticketDetailActionDanger: {
		"--ticket-action-color": "var(--atl-red)",
	},
	ticketDetailResolutionActions: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
		gap: theme.spacing(1),
		paddingTop: theme.spacing(1),
	},
	detailContainer: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(3),
		...pageControls,
	},
	detailGrid: {
		alignItems: "flex-start",
	},
	detailColumn: {
		alignContent: "flex-start",
		maxHeight: "calc(100vh - 100px)",
		overflowY: "auto",
		overflowX: "hidden",
		paddingBottom: theme.spacing(2),
		scrollbarWidth: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
		[theme.breakpoints.down('lg')]: {
			maxHeight: "none",
			overflow: "visible",
		},
	},
	detailActions: {
		display: "flex",
		justifyContent: "flex-end",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		padding: theme.spacing(1, 1.55, 1.45),
		borderTop: "1px solid var(--atl-border)",
		"& .MuiButton-root": {
			margin: 0,
		},
	},
}));
